import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import img from "../../assets/images/yi_logo.png";
import { useUserType } from "../../routes/common/UserTypeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

// My css
import css from "../../css/admin/navbar.module.css";

const Navbar = () => {
  const { userType, setUserTypeToAdmin,
    setUserTypeToUser,
    setUserTypeToInstitute,
    setUserTypeToChapterEM,
    setUserTypeToRegionEM,
  } = useUserType();
  const navigate = useNavigate();
  const [isUserTypeAvailable, setIsUserTypeAvailable] = useState()
  const [user, setUser]=useState('')
  const handleLoginClick = (e) => {
    navigate("/admin/login");
  };

  const handleLogoutClick = (e) => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userType");
    sessionStorage.removeItem("_id");
    navigate("/");
  };

  const handleProfileClick = () => {
    const userId = sessionStorage.getItem('_id');
    if (user === 'regionem') {
      navigate(`/regionem-profile/${userId}`);
    } else if (user === 'em') {
      navigate(`/em-profile/${userId}`);
    }
  };
  useEffect(() => {
    setUser(sessionStorage.getItem('userType'))
    if (!userType) {
      setIsUserTypeAvailable(false)
    }
    if (!isUserTypeAvailable) {
      // const urlParams = new URLSearchParams(window.location.search);
      let typeParam = sessionStorage.getItem('userType');

      if (typeParam === 'admin') {
        setUserTypeToAdmin()
      }
      if (typeParam === 'student') {
        setUserTypeToUser()
      }
      if (typeParam === 'institute') {
        setUserTypeToInstitute()
      }
      if (typeParam === 'em') {
        setUserTypeToChapterEM()
      }
      if (typeParam === 'regionem') {
        setUserTypeToRegionEM()
      }
    }

  }, []);
  function handleImgClick() {
    if (user === 'regionem' || user === 'admin') {
      navigate('/admin/services');
    } else {
    navigate(`/${user}/services`);
    }
  }
  function handleServiceClick() {
    console.log("service-->>>", `/${user}/services`);
    if (user === 'regionem' || user === 'admin') {
      navigate('/admin/services');
    } else {
    navigate(`/${user}/services`);
    }
  }
  const listItemStyle = { fontSize: "0.9rem", fontWeight: "400" };

  return (
    <nav className={`${css.outerNav} navbar navbar-expand-lg fixed-top`}>
      <img src={img} alt="yi-logo" className={css.yiImg} onClick={handleImgClick} />
      <button
        type="button"
        className="navbar-toggler"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbarCollapse">
        <ul className="navbar-nav mr-auto text-ff1">
          <li className="nav-item active">
            {sessionStorage.getItem("token") &&
              <div
                className="nav-link active nav-services"
                // to={`/${userType}/services`}
                style={listItemStyle}
                onClick={handleServiceClick}
              >
                Services
              </div>
            }
          </li>
        </ul>

        <ul className="navbar-nav ms-auto">
          {sessionStorage.getItem("token") ? (
            <>
              {(user === 'regionem' || user === 'em') && (
                <button
                  className={`${css.navBtn} text-ff1 navbar-right`}
                  onClick={handleProfileClick}
                  style={{ marginRight: "10px" }}
                >
                  My Profile <FontAwesomeIcon icon={faUser} style={{ color: "white", marginLeft: "4px" }} />
                </button>
              )}
            <button
              className={`${css.navBtn} text-ff1 navbar-right`}
              onClick={handleLogoutClick}
            >
              Logout
            </button>
            </>
          ) : (
            <></>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
